<div class='modal-header' (click)='$event.stopPropagation()'>
  <h4 class='modal-title'>{{ "TITLE.OBSOLETE_ARCHIVE" | translate}}</h4>
</div>

<div class='modal-body'>
  <div style="width: 100%; height: 400px">
    <ag-grid-angular
      class='ag-theme-balham w-100 h-100'
      *ngIf="!loading"
      [gridOptions]="gridOptions"
      [detailCellRenderer]="detailCellRenderer"
      [tooltipShowDelay]="tooltipShowDelay"
      [tooltipHideDelay]="tooltipHideDelay"
      [alwaysShowVerticalScroll]="true"
      [masterDetail]="true"
      [isRowMaster]="isRowMaster"
    ></ag-grid-angular>

    <ng-template #noteCol let-node>
      <span
        [ngbTooltip]='node.row.description' container='body'>{{node.row.description}}</span>
    </ng-template>

    <ng-template #actionCol let-node>
      <ion-icon class='text-danger ion-icon'
                [ngbTooltip]='"LABELS.DELETE" | translate' container='body'
                name='{{IconDelete}}'
                [ngStyle]="{'font-size': 18 + 'px'}"
                (click)="deleteRow(node.row)"></ion-icon>
    </ng-template>

    <ng-template #obsoleteCol let-node>
      <pt-obsolete-details class="display-contents" [docId]="node?.row?.docId"></pt-obsolete-details>
    </ng-template>
  </div>
</div>

<div class='modal-footer'>
  <button type='button' class='btn btn-outline-secondary btn-sm'
          (click)='activeModal.close(false)'>
    {{ 'BUTTON.CLOSE' | translate }}
  </button>
</div>

